import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getRole } from '../../../../services/role.service';
import { Role } from '../../../../types/Role';
import RolePolicies from './rolePolicies';

export default function RoleOverview() {
  const { id } = useParams();
  const [role, setRole] = useState<Role>();

  if (!id) {
    return <>Really need an id...</>;
  }

  useEffect(() => {
    getRole(id).then((response) => {
      if (response.status === 200) {
        setRole(response.data);
      }
    });
  }, [id]);

  if (role === undefined) {
    return <>Waiting for role to load...</>;
  }

  return (
    <>
      <h1>Role: {role.name}</h1>
      <RolePolicies role={role} setRole={setRole} />
    </>
  );
}
